import PropTypes from 'prop-types';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { isValidEmail } from 'LoginUI/lib/LoginUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailInputForm = ({
  email,
  onEmailChange,
  submitting,
  useDark
}) => {
  const isValid = () => {
    return !!email && isValidEmail(email);
  };
  const [emailFocused, setEmailFocused] = useState(false);
  const error = email !== '' && !emailFocused && !isValid();
  return /*#__PURE__*/_jsx(FormControl, {
    htmlFor: "username",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.form.email"
    }),
    error: error,
    validationMessage: error && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.formValidation.invalidEmail"
    }),
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "email-input-field",
      autoFocus: true,
      disabled: submitting,
      id: "username",
      onBlur: () => setEmailFocused(false),
      onFocus: () => setEmailFocused(true),
      onChange: e => onEmailChange(e.target.value),
      type: "email",
      value: email,
      use: useDark ? 'on-dark' : 'default'
    })
  });
};
EmailInputForm.propTypes = {
  useDark: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired
};
export default EmailInputForm;